import { AlertDialogProps, Root } from '@radix-ui/react-alert-dialog';

export { type AlertDialogProps };

export const AlertDialog = Root;
